<mat-toolbar class="subtitulo">{{titulo}}</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formConsultarDepartamento="ngForm">
            <div fxLayout="column" fxLayoutAlign="start center">
                <mat-toolbar class="titulopartes">Nome empresa</mat-toolbar>
                <div fxLayout="row" fxLayoutGap="50px" fxFlexFill>
                    <div ngModelGroup="comboEmpresa" fxLayoutGap="50px" fxFlexFill>
                        <combo-empresa  [selecionado]="filtroEmpresa.empresa"
                                        [tipoEmpresa]="tipo"
                                        (valorChange)="onValorChangeEmpresa($event)">
                        </combo-empresa>
                    </div>
                </div> 
            </div>

            <div fxLayout="column" fxLayoutAlign="start center">
                <mat-toolbar class="titulopartes">CNPJ Empresa</mat-toolbar>
                <div fxLayout="row" fxLayoutGap="50px" fxFlexFill>
                    <div ngModelGroup="comboCnpjEmpresa" fxLayoutGap="50px" fxFlexFill>
                        <combo-empresa  [selecionado]="filtroEmpresa.empresa"
                                        [tipoEmpresa]="tipo"
                                        [campoPesquisavel]="campoPesquisavelCnpj"
                                        (valorChange)="onValorChangeEmpresa($event)">
                        </combo-empresa>
                    </div>
                </div> 
            </div>

            <div dir="rtl" class="botoes" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;" fxFlexFill>
                <button mat-raised-button fxFlex="20%" (click)="consultar()">
                    CONSULTAR
                </button>

                <button mat-raised-button fxFlex="20%" style="padding-right: 20px" (click)="limpar()" route>
                    LIMPAR
                </button>
            </div>
        </form>
        <div fxLayout="row"  *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px" style="padding-top: 5px">
            <button matTooltip="Adicionar" mat-fab color="primary"
                (click)="go()" >
                <mat-icon>add</mat-icon>
            </button>
        </div>


        <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource" style="margin-top: 20px">

             <ng-container matColumnDef="nomeRazaoSocial">
                <th mat-header-cell *matHeaderCellDef> Razão Social: </th>
                <td mat-cell *matCellDef="let element"> {{element.nomeRazaoSocial}} </td>
              </ng-container>

              <ng-container matColumnDef="cnpj">
                <th mat-header-cell *matHeaderCellDef> CNPJ:  </th>
                <td mat-cell *matCellDef="let element"> {{element.cnpj | cnpj}} </td>
              </ng-container>

              <ng-container matColumnDef="telefone">
                <th mat-header-cell *matHeaderCellDef> Telefone:  </th>
                <td mat-cell *matCellDef="let element"> {{element.telefone}} </td>
              </ng-container>
              
              <ng-container matColumnDef="ativa">
                <th mat-header-cell *matHeaderCellDef> Ativa:  </th>
                <td mat-cell *matCellDef="let element"> {{element.ativa === 'S' ? 'Sim' : 'Não'}} </td>
              </ng-container>

              <ng-container matColumnDef="acoes">
                <th mat-header-cell *matHeaderCellDef> Ações </th>
                <td mat-cell *matCellDef="let element">
                    <button *ngIf="perfilAcesso.deleta"  mat-button (click)="deletar(element)">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button *ngIf="perfilAcesso.consulta" mat-button (click)="atualizar(element)">
                        <mat-icon>search</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div [hidden]="!mostrarTabela">
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
        <ng-template #tabelaSemDados>
            <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 20px">
                {{msg}}
            </div>
        </ng-template>

    </div>
</div>

